import { WIFI_STRENGTH } from '../../operational-data-common/translations';

export const DBM_RANGES: DbmRange[] = [
  {
    from: 0,
    to: -50,
    strength: WIFI_STRENGTH.excellent,
  },
  {
    from: -50,
    to: -60,
    strength: WIFI_STRENGTH.good,
  },
  {
    from: -60,
    to: -67,
    strength: WIFI_STRENGTH.medium,
  },
  {
    from: -67,
    to: -90,
    strength: WIFI_STRENGTH.low,
  },
  {
    from: -90,
    to: -Infinity,
    strength: WIFI_STRENGTH.off,
  },
];

export interface DbmRange {
  strength: string;
  from: number;
  to: number;
}
